// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post, request, requestVoid } from "@insite/client-framework/Services/ApiService";

export interface LoadYoutubePlaylistApiParameter extends ApiParameter {
    playlistId: string;
    youTubeApiKey: string;
}

interface PageInfo {
    totalResults: number;
    resultsPerPage: number;
}

interface Item {
    kind: string;
    etag: string;
    id: string;
    snippet: Snippet;
    contentDetails: ContentDetails;
}

interface ContentDetails {
    videoId: string;
    videoPublishedAt: string;
}

interface Snippet {
    publishedAt: string;
    channelId: string;
    title: string;
    description: string;
    thumbnails: Thumbnails;
    channelTitle: string;
    playlistId: string;
    position: number;
    resourceId: ResourceId;
}

interface ResourceId {
    kind: string;
    videoId: string;
}

interface Thumbnails {
    default: Default;
    medium: Default;
    high: Default;
    standard: Default;
    maxres: Default;
}

interface Default {
    url: string;
    width: number;
    height: number;
}

interface PlaylistModel {
    kind: string;
    etag: string;
    nextPageToken: string;
    items: Item[];
    pageInfo: PageInfo;
}

const youtubePlaylistUrl = "https://www.googleapis.com/youtube/v3/playlists";

const youtubePlaylistVideosUrl = "https://www.googleapis.com/youtube/v3/playlistItems";

export function loadYoutubePlaylistApi(parameter: LoadYoutubePlaylistApiParameter) {
    const combinationQueryString = `${youtubePlaylistUrl}?key=${parameter.youTubeApiKey}&id=${parameter.playlistId}&part=contentDetails,snippet`;
    return get<PlaylistModel>(`${combinationQueryString}`);
}

export function loadYoutubePlaylistVideosApi(parameter: LoadYoutubePlaylistApiParameter) {
    const combinationQueryString = `${youtubePlaylistVideosUrl}?key=${parameter.youTubeApiKey}&playlistId=${parameter.playlistId}&part=contentDetails,snippet`;
    return get<PlaylistModel>(`${combinationQueryString}`);
}
